const en = {
  LanguageName: 'English',
  Intro: 'Cashback is provided when a vehicle fills diesel from a Wheelseye partner pump. Register now.',
  NamePlaceholder: 'Enter Name',
  NameError: 'Please enter your name',
  PhonePlaceholder: 'Enter Phone No.',
  PhoneError: 'Please enter your Phone No.',
  PhoneErrorMin: 'Please enter 10 digits.',
  PhoneErrorMax: 'Please enter only 10 digits.',
  TruckLabel: 'Truck ',
  TruckPlaceholder: 'Enter Truck No.',
  TruckError: 'Please enter at least one Truck No.',
  AddMoreTrucks: 'Add more Trucks',
  Submit: 'Get Cashback',
  Partners: 'Our Partners',
  HindustanPetroleum: 'Hindustan Petroleum',
  IndianOil: 'Indian Oil',
  ReliancePetroleum: 'Reliance Petroleum',
  BharatPetroleum: 'Bharat Petroleum',
  Essar: 'Essar',
  SuccessTitle: 'Registration Successful',
  SuccessText: 'Our client executive will contact you soon.',
};

const hi = {
  LanguageName: 'हिन्दी',
  Intro: 'कैशबैक तब प्रदान किया जाता है जब कोई वाहन Wheelseye पार्टनर पंप से डीजल भरता है। अभी रजिस्टर करें।',
  NamePlaceholder: 'नाम दर्ज करें',
  NameError: 'अपना नाम दर्ज करें',
  PhonePlaceholder: 'फोन नंबर दर्ज करें',
  PhoneError: 'अपना फोन नंबर दर्ज करें',
  PhoneErrorMin: 'कृपया 10 अंक दर्ज करें',
  PhoneErrorMax: 'कृपया केवल 10 अंक दर्ज करें',
  TruckLabel: 'गाड़ी ',
  TruckPlaceholder: 'गाड़ी नंबर दर्ज करें',
  TruckError: 'कृपया कम से कम एक गाड़ी नंबर दर्ज करें',
  AddMoreTrucks: 'अधिक गाड़ी जोड़ें',
  Submit: 'कैशबैक प्राप्त करें',
  Partners: 'हमारे सहयोगी',
  HindustanPetroleum: 'हिंदुस्तान पेट्रोलियम',
  IndianOil: 'इंडियन ऑयल',
  ReliancePetroleum: 'रिलायंस पेट्रोलियम',
  BharatPetroleum: 'भारत पेट्रोलियम',
  Essar: 'एस्सार',
  SuccessTitle: 'रजिस्ट्रेशन सफल',
  SuccessText: 'हमारे ग्राहक कार्यकारी जल्द ही आपसे संपर्क करेंगे।',
};

const Constants = {
  undefined: en,
  en: en,
  hi: hi,
};

export default Constants;
